/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExceptionSummary
 */
export interface ExceptionSummary {
    /**
     * 
     * @type {string}
     * @memberof ExceptionSummary
     */
    taskGroupName: string;
    /**
     * 
     * @type {string}
     * @memberof ExceptionSummary
     */
    exception: string;
    /**
     * 
     * @type {string}
     * @memberof ExceptionSummary
     */
    traceback: string;
    /**
     * 
     * @type {number}
     * @memberof ExceptionSummary
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof ExceptionSummary
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof ExceptionSummary
     */
    stop?: number;
}

/**
 * Check if a given object implements the ExceptionSummary interface.
 */
export function instanceOfExceptionSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "taskGroupName" in value;
    isInstance = isInstance && "exception" in value;
    isInstance = isInstance && "traceback" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ExceptionSummaryFromJSON(json: any): ExceptionSummary {
    return ExceptionSummaryFromJSONTyped(json, false);
}

export function ExceptionSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExceptionSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'taskGroupName': json['task_group_name'],
        'exception': json['exception'],
        'traceback': json['traceback'],
        'count': json['count'],
        'start': !exists(json, 'start') ? undefined : json['start'],
        'stop': !exists(json, 'stop') ? undefined : json['stop'],
    };
}

export function ExceptionSummaryToJSON(value?: ExceptionSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'task_group_name': value.taskGroupName,
        'exception': value.exception,
        'traceback': value.traceback,
        'count': value.count,
        'start': value.start,
        'stop': value.stop,
    };
}

